import { DiscreteEvent } from '@utils/customEvents'

export const PREFIX = '[AUTH] '

export type AuthFlow = 'enroll' | 'renewal' | 'unknown'

type ExperimentMeta = {
  experimentEnabled: string
  experimentVariant: string
  experimentUID: string
}

export type AuthPipeMeta = {
  xCLEARCorrelationInfo: string
  authFlowSessionId: string
  flow: AuthFlow
  route: string
} & ExperimentMeta

export type ResultMeta = { [key: string]: unknown }

export type InitiateResult = (
  | { status: 'begin' }
  | { status: 'success'; hasOtpSessionId: boolean }
  | { status: 'failure'; error: unknown }
) &
  ResultMeta

export type VerifyResult = (
  | { status: 'begin' }
  | { status: 'success'; hasDesiredPath: boolean }
  | { status: 'failure'; error: unknown; attempts: number }
) &
  ResultMeta

export type SignInResult = (
  | { status: 'begin'; page: string }
  | { status: 'success' }
  | { status: 'failure'; error: unknown }
) &
  ResultMeta

export type SubmitCitizenshipResult = (
  | { status: 'begin' }
  | { status: 'success'; existenceStatus: string; expirationDate?: Date }
  | { status: 'failure'; error: unknown }
) &
  ResultMeta

export type SubmitIdentityResult = (
  | { status: 'begin' }
  | { status: 'success' }
  | { status: 'failure'; error: unknown }
) &
  ResultMeta

export type SearchEligibilityResult = (
  | { status: 'begin' }
  | { status: 'success' }
  | { status: 'failure'; error: unknown }
) &
  ResultMeta

export type AcceptCoppaResult = (
  | { status: 'begin' }
  | { status: 'success' }
  | { status: 'failure'; error: unknown }
) &
  ResultMeta

export type RenewalEligibilityResult = (
  | { status: 'begin' }
  | { status: 'success' }
  | { status: 'failure'; error: unknown }
) &
  ResultMeta

export type AuthViewEvent =
  | DiscreteEvent.YOU_VIEW
  | DiscreteEvent.AUTH_VIEW
  | DiscreteEvent.ELIGIBILITY_VIEW
